import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from '@michelin/central-provider';
import {
  Container, Fab, GlobalActions, LoadingBounce,
} from '@michelin/acid-components';
import { Paper } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import useUtils from 'hooks/useUtils';
import usePermissionsSPP from 'hooks/usePermissionsSPP';
import { ChangeLogEntities } from 'Types';
import LastModified from 'components/ChangeLog/LastModified';
import { PageTitle } from 'Utils/CanvasPageTitle';
import ContactsListTable from './ListTable';

export function ContactsList() {
  const { stNumber, btNumber } = useParams<{ stNumber: string, btNumber: string }>();
  const { t } = useTranslation();
  const { subTitle } = useUtils();
  const history = useHistory();
  const permissions = usePermissionsSPP();

  if (permissions.isLoading) { return <LoadingBounce style={{ height: '70vh' }} />; }
  if (!permissions.allowsAction('contacts.list', true)) {
    history.push('/');
  }

  return (
    <>
      <PageTitle
        title={t('Contacts')}
        subtitle={subTitle}
        rightItems={(<LastModified entity={ChangeLogEntities.contacts} />)}
      />
      <Container>
        <Paper>
          <ContactsListTable stNumber={stNumber} btNumber={btNumber} contactLevel="All" />
          <GlobalActions>
            <Fab
              color="primary"
              aria-label={t('Add')}
              onClick={() => history.push(`/${btNumber}/contacts/${stNumber}/add`)}
              disabled={!permissions.allowsAction('contacts.create')}
            >
              <Add />
            </Fab>
          </GlobalActions>
        </Paper>
      </Container>
    </>
  );
}
